import { Injectable, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { GlobalVariable } from "../app.component";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DataService {
  BASE_API: string = GlobalVariable.BASE_API_URL;
  private API_LIST = GlobalVariable;
  response_data: any;

  constructor(
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private http: HttpClient
  ) {}

  /**
   * Common Http get method
   * @param customApiUrl
   * @param id
   * @param slug
   * @param cust_id
   */
  get(
    customApiUrl,
    id = null,
    slug = null,
    cust_id = null
  ): Observable<Response> {
    return this.http
      .get(this.BASE_API + customApiUrl + "?slug=" + slug, {
        observe: "response",
      })
      .pipe(map((res) => this.returnValue(res)));
  }

  delete(customApiUrl, id = null, out_let = null) {
    // const myParams = { 'outlet_id': out_let, 'template_id': id };
    return this.http
      .delete(this.BASE_API + customApiUrl)
      .pipe(map((res) => this.returnValue(res)));
  }
  getRequest({
    customApiUrl = "",
    slug = null,
    date = null,
    slot_time = null,
    outlet_id = null,
  }: getRequestInterface = {}) {
    let queryParams = {
      ...(slug !== null && { slug }),
      ...(date !== null && { date }),
      ...(slot_time !== null && { slot_time }),
      ...(outlet_id !== null && { outlet_id }),
    };

    return this.http
      .get(`${this.BASE_API}${customApiUrl}`, {
        params: queryParams,
        observe: "response",
      })
      .pipe(map((res) => this.returnValue(res)));
  }

  /**
   * Common http post method with json data
   * @param customApiUrl
   * @param data
   */
  postjson(customApiUrl, data = null): Observable<Response> {
    return this.http
      .post(this.BASE_API + customApiUrl, data, { observe: "response" })
      .pipe(map((res) => this.returnValue(res)));
  }

  /**
   *Common update function put method
   * @param {*} customApiUrl
   * @param {*} data
   * @param {*} id
   * @memberof DataService
   */
  put(customApiUrl, slug = null, id = null, flag = null) {
    if (id !== null && flag === null) {
      return this.http
        .put(this.BASE_API + customApiUrl + "?slug=" + id, slug, {
          observe: "response",
        })
        .pipe(map((res) => this.returnValue(res)));
    } else {
      return this.http
        .put(this.BASE_API + customApiUrl, slug, { observe: "response" })
        .pipe(map((res) => this.returnValue(res)));
    }
  }
  putRequest({
    customApiUrl = "",
    data = {},
    date = "",
    slot_time = "",
  }: putRequestInterface = {}) {
    let queryParams = {
      ...(date !== "" && { date }),
      ...(slot_time !== "" && { slot_time }),
    };

    return this.http
      .put(`${this.BASE_API}${customApiUrl}`, data, {
        params: queryParams,
        observe: "response",
      })
      .pipe(map((res) => this.returnValue(res)));
  }

  postRequest({
    customApiUrl = "",
    data = {},
    date = "",
    slot_time = "",
    product = "",
  }: postRequestInterface = {}) {
    let queryParams = {
      ...(product !== "" && { product }),
      ...(date !== "" && { date }),
      ...(slot_time !== "" && { slot_time }),
    };

    return this.http
      .post(`${this.BASE_API}${customApiUrl}`, data, {
        params: queryParams,
        observe: "response",
      })
      .pipe(map((res) => this.returnValue(res)));
  }

  /**
   * Return respospone funtion
   * @param res ;
   */
  returnValue(res: any): Response {
    let response = <Response>{};
    response = { data: res.body, code: res.status };
    return response;
  }
}

export interface Response {
  data: string;
  code: number;
}

/**
 * adding header and Authorization methods
 * const head = new Headers({ 'Content-type': 'application/json; charset=utf-8',
 * 'Authorization': 'Bearer ${this.storage.get('access_token')}' });
 * const options = new RequestOptions({ headers: head , params: myParams});
 */

interface getRequestInterface {
  customApiUrl?: string;
  slug?: string;
  date?: string;
  slot_time?: string;
  outlet_id?: string;
}
interface putRequestInterface {
  customApiUrl?: string;
  date?: string;
  slot_time?: string;
  data?: any;
}
interface postRequestInterface {
  customApiUrl?: string;
  date?: string;
  slot_time?: string;
  data?: any;
  product?: any;
}
